import React from "react";
import { useTranslation } from "react-i18next";

function ModalFooter({
  onClickButton,
  onClickAltButton,
  hrefButton = "#_",
  hrefAltButton = "#_",
  showAltButton = true,
  extraAltButton = <div></div>,
  classNameButton = "button save",
  classNameAltButton = "button alt",
  buttonText = "Save",
  altButtonText = "Discard",
  isSubmitButton = false,
  tabIndex,
  error = false,
  formId,
  disabled = false,
}) {
  const { t } = useTranslation("common");
  const displayButtonText =
    buttonText === "Save" ? t("save") : buttonText;
  const displayAltButtonText =
    altButtonText === "Discard" ? t("discard") : altButtonText;

  let tabIndexVar = tabIndex;
  let succeedButton = isSubmitButton ? (
    <button
      {...(typeof tabIndex !== "undefined" ? { tabIndex: tabIndexVar++ } : {})}
      className={classNameButton}
      data-button-type="primary"
      onClick={onClickButton}
      type="submit"
      form={formId ? formId : undefined}
      disabled={disabled}
    >
      {displayButtonText}
    </button>
  ) : (
    <a
      {...(typeof tabIndex !== "undefined" ? { tabIndex: tabIndexVar++ } : {})}
      className={classNameButton}
      role="button"
      data-button-type="primary"
      {...(!!onClickButton
        ? { onClick: onClickButton, href: "#_" }
        : { href: hrefButton })}
    >
      {displayButtonText}
    </a>
  );

  return (
    <footer>
      {showAltButton && (
        <div className="column" data-col="">
          <a
            {...(typeof tabIndex !== "undefined"
              ? { tabIndex: tabIndex++ }
              : {})}
            className={classNameAltButton}
            role="button"
            data-button-type="secondary"
            href={hrefAltButton}
            onClick={onClickAltButton}
          >
            {displayAltButtonText}
          </a>
        </div>
      )}
      {extraAltButton}
      {error && <span className="error-label">{error}</span>}
      <div className="column" data-col="">
        {succeedButton}
      </div>
    </footer>
  );
}

export default ModalFooter;
